import { render, staticRenderFns } from "./OBackground.vue?vue&type=template&id=2b4cb620&"
import script from "./OBackground.vue?vue&type=script&lang=js&"
export * from "./OBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports